export default __webpack_public_path__ + "bing-fallback-pc.562c22727a0696083bd2084e8aee0800.png";